import { useState, useEffect } from "react";
import ContentBlockComponent from "../../components/content_block";
import { translate } from "../../translations";
import APIclient from "../../api-client";
import { ContentBlock, StaticPage, Stored } from "../../types";

export default function UserGuide() {
  const [blocks, setBlocks] = useState<Array<Stored<ContentBlock>>>([]);

  useEffect(() => {
    APIclient.contentBlocks.index(StaticPage.UserGuide).then(setBlocks);
  }, []);

  return (
    <>
      <h1 className="page__title">
        <span className="--highlighted">
          {translate("general.staticPages.userGuide.title")}
        </span>
      </h1>
      <section className="static-content">
        {blocks.map((block) => (
          <ContentBlockComponent block={block} key={block._id} />
        ))}
      </section>
    </>
  );
}
